import { useEffect, useState } from 'react'

const MOBILE_WIDTH = 800

/**
 * Checks if the screen is mobile by checking the width of the screen.
 * Code taken from https://stackoverflow.com/q/39435395.
 * There are libraries to check for mobile devices, but it seems like they might not be fully reliable.
 * Since we intend to be on mobile eventually, we should be able to use this as a temporary solution.
 * @returns true if the screen is mobile, false otherwise
 */
const useCheckMobileScreen = () => {
  const [width, setWidth] = useState(window.innerWidth)
  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  return width <= MOBILE_WIDTH
}

export default useCheckMobileScreen
